import React from "react";

const ScenarioPost = ({ quiz }) => {
  return (
    <div className="post-card">
      <div className="post-header">
        <img
          src="https://api.dicebear.com/7.x/initials/svg?seed=A"
          alt="anonymous avatar"
          className="avatar"
        />
        <div className="post-info">
          <div className="username">Anonymous</div>
          <div className="timestamp">2h · Social Media</div>
        </div>
      </div>

      <div className="post-title">{quiz.title}</div>
      <p className="post-body">{quiz.post}</p>

      {quiz.image_url && (
        <img src={quiz.image_url} alt="scenario" className="post-image" />
      )}

      <div className="reaction-bar">
        <span>👍 1.2k</span>
        <span>💬 243</span>
        <span>🔁 87</span>
      </div>
    </div>
  );
};

export default ScenarioPost;
